import { Icon, ObjectList } from "web/components"
import { useDialogModal } from "web/hooks/modals"
import API from "web/hooks/data/api"

import { TrashIcon } from "@heroicons/react/24/outline"

function RemovalError({ errors }) {
  const pronoun =
    errors.length === 1 ? "this counterparty" : "these counterparties"
  return (
    <div className="mt-5 rounded-md bg-red-50 p-4">
      <div className="flex">
        <div className="shrink-0">
          <Icon name="x-circle" className="size-5 text-red-400" />
        </div>
        <div className="ml-3">
          <div className="text-sm text-red-700">
            <p>{`There was a problem removing ${pronoun}.`}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default function Counterparties({
  rootURL,
  availableViews,
  defaultView,
  subjectType,
  parentSubjectType,
  parentSubjectId,
  breadcrumbs,
  fetchURL,
  handleClick,
  handleAddItem,
  removeItemUrl,
  enableRemoval,
  enableEdit,
  exportPath,
}) {
  async function removeCounterparties({ counterpartyIds }) {
    const removePromises = counterpartyIds.map((counterpartyId) =>
      API.delete(`${removeItemUrl}/${counterpartyId}`)
    )

    return await Promise.all(removePromises)
  }

  const removeCounterpartyErrorDialog = useDialogModal()

  const confirmRemoveCounterpartyModal = useDialogModal({
    title: "Remove Counterparties",
    prompt: "Are you sure you want to remove the selected counterpart(ies)?",
    commands: [{ label: "Remove", variant: "primary_danger", response: true }],
  })

  async function handleRemoveCounterparty({
    all: allCounterparties,
    selected: counterparties,
  }) {
    const dialogResult = await confirmRemoveCounterpartyModal()
    if (dialogResult && dialogResult.response) {
      const results = await removeCounterparties({
        counterpartyIds: counterparties.map((a) => a.id),
      })

      const errors = results.filter((result) => result.hasOwnProperty("error"))

      if (errors.length > 0) {
        await removeCounterpartyErrorDialog({
          title: "Cannot Remove Counterparty(ies)",
          prompt: <RemovalError errors={errors} />,
          heightPixels: 400,
        })
      }

      allCounterparties.refresh()
    }
  }

  const selectedItemActions = []
  if (enableRemoval) {
    selectedItemActions.push({
      label: "Remove",
      icon: TrashIcon,
      action: handleRemoveCounterparty,
    })
  }

  return (
    <ObjectList
      rootUrl={rootURL}
      canRedirectToRootUrl={false}
      availableViews={availableViews}
      defaultView={defaultView}
      subjectType={subjectType}
      parentSubjectType={parentSubjectType}
      parentSubjectId={parentSubjectId}
      breadcrumbs={breadcrumbs}
      fetchURL={fetchURL}
      onItemClick={handleClick}
      onAdd={handleAddItem}
      selectedItemActions={selectedItemActions}
      enableEdit={enableEdit}
      enableExport={true}
      exportPath={exportPath}
      enableLocationIndex={true}
      isFavouriteEnabled={false}
    />
  )
}
